import type { CSSProperties } from 'react';

import classNames from 'classnames';

import type { NavbarMenuBurgerContentElementProps } from '../../navbarElement/Navbar.type';
import * as styles from '../Navbar.css';

export function NavbarMenuBurgerContentV2(props: NavbarMenuBurgerContentElementProps) {
  const { element, children, className, attributes } = props;
  const { customAttributes } = element.attrs || {};

  const isOpen = attributes?.['data-is-open'] === true;

  return (
    // biome-ignore lint/a11y/useValidAriaRole: none
    <div
      {...props}
      role="none"
      {...customAttributes}
      {...attributes}
      className={classNames(styles.navbarMenuBurgerContentV2)}
      style={
        {
          maxHeight: isOpen ? 'fit-content' : '0px',
          height: isOpen ? 'fit-content' : '0px',
          overflow: isOpen ? 'auto' : 'hidden',
          opacity: isOpen ? 1 : 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'start',
        } as CSSProperties
      }
    >
      {/* biome-ignore lint/a11y/useValidAriaRole: none */}
      <div
        role="none"
        className={classNames(
          styles.navbarMenuBurgerContentInnerV2,
          className,
          customAttributes?.className,
          'navbar-menu-burger-content',
        )}
        style={
          {
            width: '100%',
          } as CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
}
